import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style.css";
import VueRecaptcha from "vue-recaptcha-v3";
import { createHead } from "@vueuse/head";

const app = createApp(App);

app.config.globalProperties.$API_BASEURL = "https://api.atlasimprov.com/";
app.config.globalProperties.$API_ASSETS = "https://api.atlasimprov.com/assets/";
app.config.globalProperties.$API_GRAPHQL =
  "https://api.atlasimprov.com/graphql/";
app.config.globalProperties.$TICKETS_URL =
  "https://atlasimprov.crowdwork.com/shows";
app.config.globalProperties.$PHONE_NO = "https://api.atlasimprov.com/graphql/";
app.config.globalProperties.$CLASS_URL =
  "https://atlasimprov.crowdwork.com/classes";
app.config.globalProperties.$FWBASE =
  "https://atlasimprov.crowdwork.com";

app.use(VueRecaptcha, { siteKey: "6LdnG1AqAAAAAA1soTEDyDTYwj0lexKCwP2fbCus" });

const head = createHead();
app.use(head);

app.use(router);
app.use(store);
app.mount("#app");
